import React from 'react';
import {
  Navbar,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';

function DrBellyFooter(args) {

  return (
    <div>
      <Navbar {...args}>
          <Nav className="mx-auto" navbar>
            <NavItem>
              <NavLink href="#"> © 2025 Copyright: Dr. Belly's LLC</NavLink>
            </NavItem>
          </Nav>
      </Navbar>
    </div>
  );
}

export default DrBellyFooter;